import {
    Component,
    ViewChild,
    AfterViewInit,
} from '@angular/core';
import * as $ from 'jquery';
import { CairoService, JobCancel } from './cairo.service';
import { AuthService } from '../auth/auth.service';
import { CairoChartComponent } from './chart.component';
import { NgProgress } from "ngx-progressbar";
import { xyzFromSpectrum } from './color';
import { isBraslabCsv, braslabToWave } from './braslab';
import {
    MachineSelectorComponent,
    RecipeSelectorComponent,
    SubstrateSelectorComponent,
    SpectrophotometerComponent,
    TableValuesComponent,
    ColorSwatchComponent
} from './fittings.controls.component';

@Component({
    selector: 'app-fittings',
    templateUrl: './fittings.component.html',
    styleUrls: ['./fittings.component.css']
})
export class FittingsComponent implements AfterViewInit {
    private client: string;

    @ViewChild(MachineSelectorComponent, {static: false}) machineSelector !: MachineSelectorComponent;
    @ViewChild(RecipeSelectorComponent, {static: false}) recipeSelector !: RecipeSelectorComponent;
    @ViewChild(SubstrateSelectorComponent, {static: false}) substrateSelector !: SubstrateSelectorComponent;
    @ViewChild(SpectrophotometerComponent, {static: false}) spectroSelector !: SpectrophotometerComponent;
    @ViewChild(TableValuesComponent, {static: false}) valuesComponent;
    @ViewChild(ColorSwatchComponent, {static: false}) colorSwatch !: ColorSwatchComponent;

    constructor(
        private srv: CairoService,
        private auth: AuthService,
        private ngProgress: NgProgress,
    ) { 
        this.client = this.auth.shop_id();
    }

    ngAfterViewInit() {
        this.onCustomerSelection(this.client);
    }    

    private onCustomerSelection(customer: string) {
        this.client = customer;
        if (this.machineSelector) {
            this.machineSelector.load(this.client);
        }
    }

    private onMachineSelection(machine: string) {
        this.recipeSelector.load(this.client, machine);
        if (this.spectroSelector) {
            this.spectroSelector.load(this.client, machine);
        }
    }

    private onRecipeSelection(recipe: string) {
        let machine = this.machineSelector.value;
        this.substrateSelector.load(this.client, machine, recipe);
        this.valuesComponent.load(this.client, machine, recipe);
    }

    private pad(num: number, size: number): string {
        let s = num + "";
        while (s.length < size) s = "0" + s;
        return s;
    }

    private generateJobInput(): string {
        let content = '';

        let machine = this.machineSelector.value;
        let recipe = this.recipeSelector.value;
        let substrate = this.substrateSelector.value;
        let spectrophotometer: string = this.spectroSelector.value;
        let angle = this.srv.angle(spectrophotometer);
        let reference = this.srv.reference(spectrophotometer);


        content += `machine\t${this.client}${machine}\n`;
        content += `recipe\t${this.client}${machine}_${recipe}\n`;

        content += `substrate\t${substrate}\n`;
        content += `angle\t${angle}\n`;
        content += `reference\t${reference}\n`;

        let layers = this.valuesComponent.get_layers();
        let idxLayer = 0;
        for (; idxLayer < layers.length; idxLayer++) {
            let value = layers[idxLayer];
            if (value) {
                content += `th${this.pad(idxLayer + 1, 2)}\t${value}\n`
            } else {
                content += `th${this.pad(idxLayer + 1, 2)}\tNA\n`
            }
        }
        for (; idxLayer < 15; idxLayer++) {
            content += `th${this.pad(idxLayer + 1, 2)}\tNA\n`
        }

        content += `wave\treflection\n`;
        this.wave.forEach(element => {
            content += `${element[0]}\t${element[1]}\n`;
        });

        return content;
    }

    private result = null;
    private target_wave = [];
    private calculating: boolean = false;
    /** Cancel handle of the running job, null when idle. */
    private job: JobCancel = null;

    /* admin-only: seconds elapsed while calculating (shown next to "Calculating…") */
    private elapsed: number = 0;
    private elapsedTimer: any = null;

    private startTimer() {
        this.elapsed = 0;
        const start = Date.now();
        this.elapsedTimer = setInterval(() => {
            this.elapsed = Math.floor((Date.now() - start) / 1000);
        }, 250);
    }

    private stopTimer() {
        if (this.elapsedTimer) {
            clearInterval(this.elapsedTimer);
            this.elapsedTimer = null;
        }
    }

    /** Every selector has a value, a curve is imported and every layer thickness is filled in. */
    private get canCalculate(): boolean {
        return this.wave.length > 0
            && !!this.machineSelector && !!this.machineSelector.value
            && !!this.recipeSelector && !!this.recipeSelector.value
            && !!this.substrateSelector && !!this.substrateSelector.value
            && !!this.spectroSelector && !!this.spectroSelector.value
            && !!this.valuesComponent && this.valuesComponent.complete;
    }

    private calculate() {
        if (this.calculating || !this.canCalculate) { return; }
        const job: JobCancel = { cancelled: false };
        this.job = job;
        this.calculating = true;
        this.startTimer();

        this.srv.doJob(this.generateJobInput(), job)
        .then((response) => {
            if (job.cancelled) { return; }
            if (response.status) {
                this.result = response.body
                this.valuesComponent.show(this.result);
                this.colorSwatch.show(this.result);

                if (this.result.target_curve) {
                    this.target_wave = this.result.target_curve.map((item) => {
                        return [item.x, item.y];
                    });
                    this.chartComponent.add(this.target_wave);
                }
            }
            this.finishJob();
        })
        .catch((err) => {
            console.log(err);
            if (!job.cancelled) { this.finishJob(); }
        })
    }

    /** Stops waiting for the running job; whatever it returns later is ignored. */
    private stop() {
        if (!this.job) { return; }
        this.job.cancelled = true;
        this.finishJob();
    }

    private finishJob() {
        this.stopTimer();
        this.job = null;
        this.calculating = false;
    }

    private import() {
        $("#fileLoader").click();
    }

    private wave = [];
    private fileName: string = '';
    @ViewChild('mainChart', {static: false}) chartComponent: CairoChartComponent;

    private onFileSelected($event) {
        let files = $event.target.files;
        if (files.length == 1) {
            const fileName = files[0].name;
            let reader = new FileReader();

            reader.onload = (e) => {
                const text = reader.result.toString();

                if (isBraslabCsv(text)) {
                    // Braslab CSV: convert it first (see braslab.ts), then use it as any other curve
                    const converted = braslabToWave(text);
                    if ('error' in converted) {
                        alert(`${fileName}: ${converted.error}`);
                        return;
                    }
                    this.wave = converted.wave;
                } else {
                    // get parsing info
                    let spectrophotometer: string = this.spectroSelector.value;
                    let parsing_info = this.srv.parsing_info(spectrophotometer);

                    let lines: string[] = text.split('\n');

                    // remove header
                    lines = lines.slice(parsing_info.header);

                    // filter empty lines
                    lines = lines.filter(line => line.length > 0);

                    // split columns
                    let dataStr = lines.map(item => item.split(parsing_info.separator));

                    // parse numbers
                    this.wave = dataStr.map((item) => {
                        return [
                            parseFloat(item[0].replace(',', '.')),
                            parseFloat(item[1].replace(',', '.'))
                        ];
                    });
                }
                this.fileName = fileName;

                this.chartComponent.load(this.wave, 'app-fittings canvas');

                // preliminary colour straight from the curve, refined once the job runs
                const xyz = xyzFromSpectrum(this.wave);
                this.colorSwatch.showPreliminary(xyz);
                this.valuesComponent.showPreliminary(xyz);
            }

            // Braslab CSVs come in Windows-1252 (accents in their preamble)
            reader.readAsText(files[0], /\.csv$/i.test(fileName) ? 'windows-1252' : undefined);
        }
    }
};